import React, { Component } from "react";

import Link from "components/link/link";
import "./additionalInformationGroup.css";
import "./additionalInformationGroupMobile.css";

class AdditionalInformationGroup extends Component {
  constructor(props) {
    super(props);

    const items = this.props.items.map(item => {
      item.hover = false;
      return item;
    });

    this.state = {
      items
    };

    this.onClickHandler = this.onClickHandler.bind(this);
    this.onMouseEnterHandler = this.onMouseEnterHandler.bind(this);
    this.onMouseLeaveHandler = this.onMouseLeaveHandler.bind(this);
  }

  onClickHandler(event) {
    event.preventDefault();
    // set hover on item
    const index = event.currentTarget.getAttribute("index");
    this.setState(state => {
      state.items[index].hover = !state.items[index].hover;
      return state;
    });
  }

  onMouseEnterHandler(event) {
    // set hover on item
    const index = event.currentTarget.getAttribute("index");
    this.setState(state => {
      state.items[index].hover = true;
      return state;
    });
  }

  onMouseLeaveHandler(event) {
    const index = event.currentTarget.getAttribute("index");
    this.setState(state => {
      state.items[index].hover = false;
      return state;
    });
  }

  renderLabels() {
    const labels = [];
    for (let i = 0; i < this.state.items.length; i++) {
      const label = (
        <div
          className="label"
          key={i}
          index={i}
          onClick={this.onClickHandler}
          onMouseEnter={this.onMouseEnterHandler}
          onMouseLeave={this.onMouseLeaveHandler}
        >
          <p>{this.state.items[i].label}</p>
        </div>
      );
      labels.push(label);
    }
    labels.push(
      <div className="label" key="ordering-info">
        <Link to="/about/orderinginfo" key="Ordering Info">
          Ordering Info →
        </Link>
      </div>
    );
    return labels;
  }

  renderPopOvers() {
    const popOvers = [];
    for (let i = 0; i < this.state.items.length; i++) {
      const popOver = (
        <div
          className={`popOver ${
            this.state.items[i].hover === true ? "hover" : ""
          }`}
          index={i}
          key={i}
        >
          <div>{this.state.items[i].information}</div>
        </div>
      );
      popOvers.push(popOver);
    }
    return popOvers;
  }

  render() {
    return (
      <div className="additionalInformationGroup">
        <div className="labelContainer">{this.renderLabels()}</div>
        <div className="popOverContainer">{this.renderPopOvers()}</div>
      </div>
    );
  }
}
export default AdditionalInformationGroup;
